import { formatCategories } from './utils/formatCategories';
import { TAppState } from '../../../types';
import { selectBuyPackageModalData } from '../../buyPackageModal';

export const selectBuyCustomPackageAnalyticsLabel = (state: TAppState): string => {
  const { regionNames, categoriesView, durationInDays, activationDate } = selectBuyPackageModalData(state);

  const label = [
    regionNames.map(region => region.replace(/\s/g, '-')).join(','),
    formatCategories(categoriesView),
    durationInDays,
    activationDate,
  ].join('_');

  return `calculate/${label}`;
};
